import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState } from './user.state';

export const getCurrentUserState = createFeatureSelector<UserState>('currentUser');

export const getCurrentUser = createSelector(
  getCurrentUserState,
  (state) => state.currentUser
);
